import React from 'react';
import { ArrowDown } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box, Button, Typography } from '@mui/material';

interface ShowMoreButtonProps {
  showMore: boolean;
  onPress: () => void;
  showArrowIcon?: boolean;
  isListMode?: boolean;
  itemsLength?: number;
  maxLines?: number;
  displayCounter?: boolean;
}

export const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({
  showMore,
  onPress,
  showArrowIcon = false,
  isListMode = false,
  itemsLength = 0,
  maxLines = 1,
  displayCounter = false,
}) => {
  const buttonText = showMore ? 'Show Less' : 'Show More';
  const arrowIcon = <ArrowDown style={{ transform: `rotate(${showMore ? 180 : 0}deg)` }} />;

  return (
    <Box sx={{ ...flex.justifyBetweenCenter, width: '100%' }}>
      <Button sx={{ pl: 0, color: 'var(--color-content-interactive-primary-default)' }} onClick={onPress} size="xSmall">
        {buttonText}
        {showArrowIcon && arrowIcon}
      </Button>

      {isListMode && (
        <Typography variant="caption" sx={{ fontSize: '14px', color: 'var(--color-content-base-tertiary)' }}>
          {displayCounter && (showMore ? `${itemsLength}/${itemsLength}` : `${maxLines}/${itemsLength}`)}
        </Typography>
      )}
    </Box>
  );
};
